import { render, staticRenderFns } from "./AxCreateProjectCompact.vue?vue&type=template&id=30d86eb6&scoped=true&"
import script from "./AxCreateProjectCompact.vue?vue&type=script&lang=ts&"
export * from "./AxCreateProjectCompact.vue?vue&type=script&lang=ts&"
import style0 from "./AxCreateProjectCompact.vue?vue&type=style&index=0&id=30d86eb6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d86eb6",
  null
  
)

export default component.exports